import React, { useState, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import { debounce } from "lodash";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import Style from "./ProfilAddress.scss";

const ProfilAddress = ({ entity, updateStructureInfo }) => {
   const [isLoading, setIsLoading] = useState(false);
   const [billingAddress, setBillingAddress] = useState();
   const {
      register,
      control,
      handleSubmit,
      formState: { errors },
   } = useForm({
      mode: "onChange",
      defaultValues: {},
   });

   useEffect(() => {
      entity?.billing_adresses?.length ? setBillingAddress(entity?.billing_adresses[0]) : setBillingAddress(null);
   }, []);

   const submitAfterDebounce = (e) => {
      let submitBtn = document.querySelector("#ue_entity_form_hidden_submit");
      submitBtn.click();
   };

   const handleUpdateEntity = async (data) => {
      const args = data;
      args.id = entity.id;

      try {
         const result = await axios.put("/Api/user/entity", args);
         updateStructureInfo(data);
         result.data ? toast.success("Actualisation de vos données de structure réussie") : null;
      } catch (err) {
         console.log(err);
         toast.error("Un problème est survenu lors de l`'actualisation de vos données");
      }
   };

   const handleUpdateBillingAddress = (e) => {
      e.preventDefault();

      handleUpdateEntity({ billingAddress: [billingAddress] });
   };
   const handleClearBillingAddress = () => {
      setBillingAddress(null);
      handleUpdateEntity({ billingAddress: [] });
   };

   return (
      <div className={"d-flex w-100 flex-column justify-content-between align-items-center p-2 mb-5"}>
         <div className={"w-100"}>
            <div className={"w-100 d-flex justify-content-start align-items-start text-left my-2 font-weight-bold"}>
               <div className={"mr-2 "}>
                  {!billingAddress ? (
                     <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                           d="M4.5 0C2.01471 0 0 2.01471 0 4.5C0 6.98529 2.01471 9 4.5 9C6.98529 9 9 6.98529 9 4.5C9 2.01471 6.98529 0 4.5 0ZM5.95161 4.5C5.95161 5.30042 5.30042 5.95161 4.5 5.95161C3.69958 5.95161 3.04839 5.30042 3.04839 4.5C3.04839 3.69958 3.69958 3.04839 4.5 3.04839C5.30042 3.04839 5.95161 3.69958 5.95161 4.5Z"
                           fill="#58D2C3"
                        />
                     </svg>
                  ) : (
                     <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                           d="M4.5 0C2.01471 0 0 2.01471 0 4.5C0 6.98529 2.01471 9 4.5 9C6.98529 9 9 6.98529 9 4.5C9 2.01471 6.98529 0 4.5 0ZM5.95161 4.5C5.95161 5.30042 5.30042 5.95161 4.5 5.95161C3.69958 5.95161 3.04839 5.30042 3.04839 4.5C3.04839 3.69958 3.69958 3.04839 4.5 3.04839C5.30042 3.04839 5.95161 3.69958 5.95161 4.5Z"
                           fill="#BFC2C2"
                        />
                     </svg>
                  )}
               </div>
               <span style={{ color: !billingAddress ? "#000" : "#CCC" }}>Adresse principale</span>
            </div>
            <form id="ue-entity-form" onSubmit={handleSubmit(handleUpdateEntity)}>
               <div className={!billingAddress ? "w-100 ue-address-blue" : "w-100"}>
                  <div className="form-row">
                     <div className="form-group col-12">
                        <label htmlFor="name" className={"col-form-label ue-col-form-label"}>
                           Adresse
                        </label>
                        <input
                           type="text"
                           className="form-control ue-form-control"
                           id="entity_address"
                           name="entity_address"
                           {...register("address")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.address ? entity.address : ""}
                        />
                        {errors.address && <span className={"text-danger mt-1"}>Ce champ est requis !</span>}
                     </div>
                  </div>
                  <div className="form-row">
                     <div className="form-group col-12">
                        <label htmlFor="name" className={"col-form-label ue-col-form-label"}>
                           Adresse suite
                        </label>
                        <input
                           type="text"
                           className="form-control ue-form-control"
                           id="entity_address2"
                           name="entity_address2"
                           {...register("address2")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.address2 ? entity.address2 : ""}
                        />
                        {errors.address2 && <span className={"text-danger mt-1"}>Erreur !</span>}
                     </div>
                  </div>
                  <div className="form-row">
                     <div className="form-group col-4">
                        <label htmlFor="name" className={"col-form-label ue-col-form-label"}>
                           Code postal
                        </label>
                        <input
                           type="text"
                           className="form-control ue-form-control"
                           id="entity_cp"
                           name="entity_cp"
                           {...register("cp")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.cp ? entity.cp : ""}
                        />
                        {errors.cp && <span className={"text-danger mt-1"}>Erreur !</span>}
                     </div>
                     <div className="form-group col-8">
                        <label htmlFor="name" className={"col-form-label ue-col-form-label"}>
                           Ville
                        </label>
                        <input
                           type="text"
                           className="form-control ue-form-control"
                           id="entity_city"
                           name="entity_city"
                           {...register("city")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.city ? entity.city : ""}
                        />
                        {errors.city && <span className={"text-danger mt-1"}>Erreur !</span>}
                     </div>
                  </div>
               </div>
               <button type={"submit"} id={"ue_entity_form_hidden_submit"} style={{ display: "none" }} />
            </form>
         </div>
         <div className={"w-100"}>
            {!billingAddress ? (
               <div
                  className={" my-2 btn btn-primary text-white btn-block "}
                  onClick={() =>
                     setBillingAddress({
                        entity_id: entity?.id,
                        address: "",
                        addressbis: "",
                        cp: "",
                        city: "",
                     })
                  }
               >
                  + Ajouter une adresse de facturation
               </div>
            ) : (
               <div>
                  <div
                     className={"w-100 d-flex justify-content-start align-items-start text-left my-2 font-weight-bold"}
                  >
                     <div className={"mr-2 "}>
                        {billingAddress ? (
                           <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                 d="M4.5 0C2.01471 0 0 2.01471 0 4.5C0 6.98529 2.01471 9 4.5 9C6.98529 9 9 6.98529 9 4.5C9 2.01471 6.98529 0 4.5 0ZM5.95161 4.5C5.95161 5.30042 5.30042 5.95161 4.5 5.95161C3.69958 5.95161 3.04839 5.30042 3.04839 4.5C3.04839 3.69958 3.69958 3.04839 4.5 3.04839C5.30042 3.04839 5.95161 3.69958 5.95161 4.5Z"
                                 fill="#58D2C3"
                              />
                           </svg>
                        ) : (
                           <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                 d="M4.5 0C2.01471 0 0 2.01471 0 4.5C0 6.98529 2.01471 9 4.5 9C6.98529 9 9 6.98529 9 4.5C9 2.01471 6.98529 0 4.5 0ZM5.95161 4.5C5.95161 5.30042 5.30042 5.95161 4.5 5.95161C3.69958 5.95161 3.04839 5.30042 3.04839 4.5C3.04839 3.69958 3.69958 3.04839 4.5 3.04839C5.30042 3.04839 5.95161 3.69958 5.95161 4.5Z"
                                 fill="#BFC2C2"
                              />
                           </svg>
                        )}
                     </div>
                     Adresse de facturation
                     <div className={"mx-2"}>
                        <div className={"btn ue-btn-circle bg-primary"} onClick={(e) => handleClearBillingAddress()}>
                           <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-trash3-fill"
                              viewBox="0 0 16 16"
                           >
                              <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                           </svg>
                        </div>
                     </div>
                  </div>
                  <form id="ue-billind-address-form2" onSubmit={handleUpdateBillingAddress} className={"w-100"}>
                     <div className={!billingAddress ? "w-100" : "w-100 ue-address-blue"}>
                        <div className="form-row ">
                           <div className="form-group col-12">
                              <label htmlFor="name" className={"col-form-label ue-col-form-label"}>
                                 Adresse
                              </label>
                              <input
                                 type="text"
                                 required
                                 className="form-control ue-form-control"
                                 id="entity_billingAddresses_address"
                                 name="entity_billingAddresses_address"
                                 onChange={(e) => setBillingAddress({ ...billingAddress, address: e.target.value })}
                                 value={billingAddress?.address}
                                 defaultValue={""}
                              />
                              {/* {errors?.billingAddress?.address && <span className={'text-danger mt-1'}>Ce champ est requis !</span>}*/}
                           </div>
                        </div>
                        <div className="form-row">
                           <div className="form-group col-12">
                              <label htmlFor="name" className={"col-form-label ue-col-form-label"}>
                                 Adresse suite
                              </label>
                              <input
                                 type="text"
                                 className="form-control ue-form-control"
                                 id="entity_billingAddresses_addressbis"
                                 name="entity_billingAddresses_addressbis"
                                 onChange={(e) => setBillingAddress({ ...billingAddress, addressbis: e.target.value })}
                                 value={billingAddress?.addressbis}
                                 defaultValue={""}
                              />
                              {/*{errors?.billingAddress?.addressbis && <span className={'text-danger mt-1'}>Erreur !</span>}*/}
                           </div>
                        </div>
                        <div className="form-row">
                           <div className="form-group col-4">
                              <label htmlFor="name" className={"col-form-label ue-col-form-label"}>
                                 Code postal
                              </label>
                              <input
                                 type="text"
                                 required
                                 className="form-control ue-form-control"
                                 id="entity_billingAddresses_cp"
                                 name="entity_billingAddresses_cp"
                                 onChange={(e) => setBillingAddress({ ...billingAddress, cp: e.target.value })}
                                 value={billingAddress?.cp}
                                 defaultValue={""}
                              />
                              {/*{errors?.billingAddress?.cp && <span className={'text-danger mt-1'}>Erreur !</span>}*/}
                           </div>
                           <div className="form-group col-8">
                              <label htmlFor="name" className={"col-form-label ue-col-form-label"}>
                                 Ville
                              </label>
                              <input
                                 type="text"
                                 required
                                 className="form-control ue-form-control"
                                 id="entity_billingAddresses_city"
                                 name="entity_billingAddresses_city"
                                 onChange={(e) => setBillingAddress({ ...billingAddress, city: e.target.value })}
                                 value={billingAddress?.city}
                                 defaultValue={""}
                              />
                              {/*{errors?.billingAddress?.city && <span className={'text-danger mt-1'}>Erreur !</span>}*/}
                           </div>
                        </div>
                     </div>
                     <div className={"d-flex flex-column flex-md-row justify-content-between align-items-center"}>
                        <button
                           className={"btn btn-primary text-white btn-block my-1"}
                           type={"submit"}
                           id={"ue_entity2_form_hidden_submit"}
                        >
                           Enregistrer
                        </button>
                     </div>
                  </form>
               </div>
            )}
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      types: state.SubscribtionReducer.types,
      structureInfo: state.SubscribtionReducer.structureInfo,
      entity: state.MeReducer.entity,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateStructureInfo: (e) => dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(ProfilAddress);
